export type ParseValueHandler = (value?: string) => any;

export const parseBoolean = (value?: string) => {
  if (!value) {
    return false;
  }

  return ["true", "1"].includes(value.toLowerCase());
};
